import React from 'react';
import Style from './index.module.scss';

interface Props {
    refs?: React.LegacyRef<HTMLIFrameElement>;
    src?: string;
}
const Index = ({refs, src}: Props) => {
    return (
        <div className={Style.phone}>
            <iframe
                ref={refs}
                title="preview_app"
                className={Style.iframe}
                src={src}
            />
        </div>
    );
};

export default Index;
